import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getUrl, RouteName } from 'src/routing';
import { AttributeListListItem } from 'src/view/AttributeList/index';

export interface OwnProps {
  item: AttributeListListItem;
}

export interface Props extends OwnProps {

}

const AttributeListItem = ({ item }: Props) => (
  <tr>
    <td>{item.value}</td>
    <td>
      <div>
        {item.attributeTypeName}
      </div>
      <div className="small">
        {item.gApiName}
      </div>
    </td>
    <td>
      <div className="btn-group" role="group" aria-label="Basic example">
        <Link
          to={getUrl(RouteName.attributeEdit, { attributeId: item.attributeId })}
          className="btn btn-sm btn-warning"
        >
          Edit
        </Link>
      </div>
    </td>
  </tr>
);

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(AttributeListItem);
